import { render, staticRenderFns } from "./ClinexConsentFormsFragment.vue?vue&type=template&id=1bd8c5d9"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports